@if (dropdown()) {
  <div class="language-switch">
    <div class="split-trigger" [class.open]="menuOpen()">
      <button
        type="button"
        class="current-language"
        [attr.aria-expanded]="menuOpen()"
        aria-controls="language-navigation-menu"
        (click)="toggleMenu()"
      >
        <ui-icon faName="globe" faStyle="light" aria-hidden="true"></ui-icon>
        {{ activeLanguage() | uppercase }}
      </button>
      <button
        #menuToggle
        type="button"
        class="menu-toggle"
        [attr.aria-expanded]="menuOpen()"
        [attr.aria-label]="menuTitle()"
        aria-controls="language-navigation-menu"
        (click)="toggleMenu()"
      >
        <ui-icon [faName]="menuOpen() ? 'chevron-up' : 'chevron-down'" faStyle="light" aria-hidden="true"></ui-icon>
      </button>
    </div>

    @if (menuOpen()) {
      <div class="language-menu" id="language-navigation-menu">
        @if (menuTitle(); as title) {
          <p class="menu-title">{{ title }}</p>
        }
        <nav [attr.aria-label]="menuTitle()">
          @for (language of languages(); track language.language) {
            <a
              uiLink
              class="menu-language"
              [link]="language.path"
              [class.current]="activeLanguage() === language.language"
              [attr.aria-current]="activeLanguage() === language.language ? 'page' : null"
              (click)="closeMenu()"
            >{{ language.label ?? language.language }}</a>
          }
        </nav>
      </div>
    }
  </div>
} @else {
  <nav class="language-navigation">
    @for (language of languages(); track language.language; let last = $last) {
      <a
        uiLink
        class="language-button"
        [link]="language.path"
        [class.current]="activeLanguage() === language.language"
      >{{ language.language | uppercase }}</a>

      @if (!last) {
        <span class="separator">|</span>
      }
    }
  </nav>
}
